import { PageFilter } from "../../shared/components/filter";
import { PageHeading } from "../../shared/components/heading";
import request from "../../shared/utils/request";
import { useEffect, useState } from "react";
import "../myLibrary/style.css";
import { Link } from "react-router-dom";
import { Loader } from "../../shared/components/loader";
import { Slide } from "react-awesome-reveal";

export const GrammerBook = () => {
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [cardDatas, setCardDatas] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(1);

  useEffect(() => {
    getDatas();
  }, [search, page]);

  const getDatas = async () => {
    try {
      setLoading(true);
      const response = await request.post("student/getGrammerBookQuestions", {
        page: page,
        size: 12,
        filter: search,
        status: "Active",
      });
      if (response?.data?.status) {
        setCardDatas(response?.data?.grammerBooks);
        setTotalRows(response?.data?.totalRows);
      }
    } catch (error) {
      console.error("Error fetching  data:", error);
    } finally {
      setLoading(false); // Step 3: Set loading to false after the request is completed
    }
  };

  return (
    <section id="services" className="services section my-library">
      <div className="container section-title" data-aos="fade-up">
        <Slide direction="down">
          <PageHeading heading={"My Grammar Book"} />
        </Slide>
      </div>
      <Loader isLoading={loading} />
      <div className="container ">
        <PageFilter
          onChange={(event) => {
            setSearch(event.target.value);
          }}
          totalRows={totalRows}
          page={page}
          handlePageChange={(page) => setPage(page)}
        />
        <div className="row gy-1">
          {cardDatas?.map((cardData, rowIndex) => (
            <div className="col-md-4 " key={rowIndex}>
              <Slide direction="up">
                <Link to={`/student/my-grammar-book/${cardData?.id}`}>
                  <div className="card-wrapper">
                    <div className="custom-card">
                      <div className="card-body ml-2">
                        <span className="badge badge-custom text-white">
                          Click to Read
                        </span>
                        <h5 className="card-title">{cardData?.question}</h5>
                      </div>
                    </div>
                  </div>
                </Link>
              </Slide>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
